import { useEffect, useState } from "react";
import { useAppSelector } from "../../../hooks";
import { selectIsChatIdRequestPending } from "../../../modules/auth/selectors";

export const useShowLoader = () => {
  const [showLoader, setShowLoader] = useState(false);

  const isChatIdRequestPending = useAppSelector(selectIsChatIdRequestPending);

  useEffect(() => {
    setShowLoader(isChatIdRequestPending);
  }, [isChatIdRequestPending]);

  return { showLoader };
};
